import { Component } from '@angular/core';

@Component({
    selector: 'pq-unimplemented-route',
    templateUrl: './unimplemented-route.component.html',
    standalone: false
})
export class UnimplementedRouteComponent {}
